import React from 'react';
import { ReleaseFilter } from '@/layout/common-filter/filters/ReleaseFilter';
import { addReleaseFilters, clearReleaseFilters } from './releaseListSlice';

const filterActions = { addReleaseFilters, clearReleaseFilters };

export const ReleaseListFilter = () => (
  <ReleaseFilter page="RELEASE_LIST_PAGE" filterActions={filterActions} />
);
